import React from 'react';
import PropTypes from 'prop-types';

import SidebarLinks from './links';
import { GA_EVENT_CATEGORY_SIDEBAR, trackEvent } from '../../utils';

function onToggleAll(expanded) {
  trackEvent({
    eventCategory: GA_EVENT_CATEGORY_SIDEBAR,
    eventAction: 'toggle all',
    eventLabel: expanded ? 'expand' : 'collapse',
  });
}

function onToggleGroup(title, expanded) {
  trackEvent({
    eventCategory: GA_EVENT_CATEGORY_SIDEBAR,
    eventAction: 'toggle group',
    eventLabel: title,
    eventValue: Number(expanded),
  });
}

export default function SidebarContent(props) {
  return (
    <div className="sidebar">
      <SidebarLinks
        contents={props.contents}
        pathname={props.pathname}
        onToggleAll={onToggleAll}
        onToggleGroup={onToggleGroup}
      />
    </div>
  );
}

SidebarContent.propTypes = {
  contents: PropTypes.array.isRequired,
  pathname: PropTypes.string.isRequired,
};
